import { Star } from 'lucide-react';
import { Breadcrumbs } from './PageElements';
import '../../about.css';

export const AboutHero = () => <section className="about-image-hero" aria-labelledby="about-page-title" data-testid="page-hero">
  <div className="site-container"><Breadcrumbs items={[{ label: 'About' }]} /></div>
  <picture className="about-hero-artwork" data-testid="about-hero-artwork">
    <source type="image/webp"
      srcSet="/assets/about/fort-worth-480.webp 480w, /assets/about/fort-worth-768.webp 768w, /assets/about/fort-worth-1200.webp 1200w, /assets/about/fort-worth-1536.webp 1536w"
      sizes="100vw" />
    <img src="/assets/about/fort-worth-original.png" width="1536" height="1024" fetchPriority="high" decoding="async"
      alt="Longhorn Milling-branded group portrait at the Fort Worth Stockyards, with trucks, the Longhorn logo, and the words People. Roads. Texas."
      data-testid="hero-process-image" />
  </picture>
  <div className="site-container about-hero-copy">
    <p className="eyebrow" data-testid="page-eyebrow"><span aria-hidden="true" />ABOUT / LONGHORN MILLING</p>
    <h1 id="about-page-title" data-testid="page-title">Paving a stronger<br /><em>tomorrow.</em></h1>
    <p className="about-hero-description" data-testid="page-description">Milling. Paving. Striping. Built for what’s next in North Texas.</p>
    <div className="about-hero-signature" data-testid="hero-signature"><Star size={17} aria-hidden="true" />PRECISION MILLING <span aria-hidden="true">◆</span> QUALITY RESULTS</div>
  </div>
</section>;